import { Text } from '@belong/ui';
import { clsx } from 'clsx';
import { BelongStandardsLandingLink } from 'src/features/belong-standards/components/belong-standards-landing-link/belong-standards-landing-link';
import { useFeatureFlag } from 'src/features/feature-flags/hooks';
import { HOMEOWNERS_STRINGS as STRINGS } from '../../../../homeowners.strings';
import { CoverCardScrollIds } from '../gttl-cover/gttl-cover';
import css from './gttl-beloved-home.module.css';

const webmVideoSrc =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/gttl/lp_gtr_video_bubble.webm';
const mp4VideoSrc =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/gttl/lp_gtr_video_bubble.mp4';

export function GttlBelovedHome() {
  const { isEnabled: isBelongStandardsEnabled } =
    useFeatureFlag('belong-standards');

  return (
    <>
      <div
        id={CoverCardScrollIds.BelovedHome}
        className="bg-light-gray px-sm pb-2xl pt-5xl w-full text-center"
      >
        <div className={clsx(isBelongStandardsEnabled && 'mb-2xl')}>
          <Text variant="h2" fontWeight="semibold" className="mb-sm">
            {STRINGS['guaranteedTimeToLoveLanding.belovedHome.title']}
          </Text>
          <Text variant="body">
            {STRINGS['guaranteedTimeToLoveLanding.belovedHome.subtitle']}
          </Text>
        </div>
        <BelongStandardsLandingLink />
        <div className={clsx(css.videoContainer, 'my-2xl md:my-3xl mx-auto')}>
          <video
            width="100%"
            height="100%"
            autoPlay
            controls={false}
            muted={true}
            loop
            {...{
              playsInline: true,
              'webkit-playsinline': 1,
              'x5-playsinline': 1,
            }}
          >
            <source src={webmVideoSrc} type="video/webm" />
            <source src={mp4VideoSrc} type="video/mp4" />
            Sorry, your browser does not support embedded videos.
          </video>
        </div>
        <Text variant="body">
          {STRINGS['guaranteedTimeToLoveLanding.belovedHome.contactInfo']}
        </Text>
      </div>
    </>
  );
}
